export const downloadUrl = state => state.downloadUrl;
export const infotechUrl = state => state.infotechUrl;
export const actionsData = state => state.actionsData;
export const itemNotes = state => state.itemNotes;
export const tree = state => state.tree;
export const thumbnails = state => state.thumbnails;
